module.exports = __webpack_public_path__ + "static/media/visual-spec-document-gallery.5d6dc305.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/visual-spec-document-gallery.scss
// module id = 372
// module chunks = 0